import React from 'react';
import useWindowSize from '@hooks/use-window-size';
import { FlipCard } from '../../components/flip-card/flip-card';
import { Carousel } from '@components/carousel/carousel';
import {
  CardsContainer,
  ComponentGridStructure,
  Description,
  FlipCardBlockContainer,
  Title,
} from './flip-card-block.styles';
import { FlipCardBlockProps } from './flip-card-block.types';

const FlipCardBlock: React.FC<FlipCardBlockProps> = ({
  title,
  anchorId,
  description,
  flipcardTiles = [],
  className,
  colour,
  translate = true,
  displayAsCarousel = false,
}) => {
  const { width } = useWindowSize();
  const isMobile = !!width && width < 768;

  if (!flipcardTiles || flipcardTiles.length < 1) return null;

  const shouldRenderCarousel = displayAsCarousel && !isMobile;

  return (
    <FlipCardBlockContainer
      id={anchorId}
      data-testid="flip-card-block"
      className={className}
      colour={colour}
    >
      {title && <Title>{title}</Title>}
      {description && <Description>{description}</Description>}
      {shouldRenderCarousel ? (
        <Carousel
          visibleTilesCount={3}
          items={flipcardTiles.map((flipcardTile, index) => (
            <FlipCard key={index} {...flipcardTile} translate={translate} />
          ))}
          arrowTopSpacing="40%"
        />
      ) : (
        <ComponentGridStructure>
          <CardsContainer>
            {flipcardTiles.map((flipcardTile, index) => (
              <FlipCard key={index} {...flipcardTile} translate={translate} />
            ))}
          </CardsContainer>
        </ComponentGridStructure>
      )}
    </FlipCardBlockContainer>
  );
};

export default FlipCardBlock;
